import { CustomMenuCategoryCode, resolveCategoryMenuCode } from '@/constants/custom-menu-category-code';
import { CustomMenuListCode, resolveMenuCode } from '@/constants/custom-menu-list-code';
import { BuildingMenuType } from '@/enums';
import { useConfigStore } from '@/stores';
import type { BuildingMenu } from '@/services/dto';
import { useMemo } from 'react';
import { useCustomMenuContent } from './useCustomMenuContent';

export const useCurrentCustomMenu = (gnbMenuId?: string) => {
    const language = useConfigStore((state) => state.config.ui.language);
    const buildingMenus = useConfigStore((state) => state.config.server?.buildingMenus);

    const currentMenu = useMemo(() => {
        const listMenus = buildingMenus?.[language] || [];
        if (gnbMenuId) {
            return listMenus.find((menu) => menu.id === gnbMenuId && menu.menuType === BuildingMenuType.CUSTOM_MENU);
        }
        return listMenus.find((menu) => menu.menuType === BuildingMenuType.CUSTOM_MENU);
    }, [buildingMenus, language, gnbMenuId]);

    const menuId = gnbMenuId ?? currentMenu?.id;
    const customContent = useCustomMenuContent(menuId);

    const menuCode = useMemo(() => {
        if (!currentMenu) return undefined;
        const menu = currentMenu as BuildingMenu;
        if (menu.customMenuType === BuildingMenuType.CUSTOM_MENU_CATEGORY_TYPE) {
            return resolveCategoryMenuCode(menu);
        }
        return resolveMenuCode(menu);
    }, [currentMenu]);

    const isHotplace = menuCode === CustomMenuListCode.HOTPLACE;
    const isFacility = menuCode === CustomMenuCategoryCode.FACILITY;

    return {
        currentMenu,
        customContent,
        menuCode,
        isHotplace,
        isFacility,
        menuId,
    };
};
